import React from 'react';

import { withStyles } from '@material-ui/core';
import Checkbox, { CheckboxProps } from '@material-ui/core/Checkbox';
import {
  CheckCircle,
  UncheckCircle,
} from '@pages/Products/components/AddEquipmentModal/components/components.styles';
import { BigInputWithCheckBox, CheckBoxDiv, SmallText } from './styles';

export const BlueCheckbox = withStyles({
  root: {
    color: '#1371FE',
    marginRight: '0',
    '&$checked': {
      // Todo: Remove unused
      color: '#1371FE',
    },
    height: '18px',
    width: '18px',
  },
  checked: {},
})((props: CheckboxProps) => <Checkbox color="default" {...props} />);

interface OwnProps {
  showCheckbox: boolean;
  isDisabled: boolean;
  placeholder: string;
  value: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  onClick: () => void;
  isHiddenDisabled?: boolean;
}

export const BigCheckBoxInput = ({
  showCheckbox,
  isDisabled,
  placeholder,
  value,
  onChange,
  onClick,
  isHiddenDisabled,
}: OwnProps) => {
  return (
    <>
      <BigInputWithCheckBox
        type="text"
        isVisible={showCheckbox}
        disabled={isDisabled || isHiddenDisabled}
        data-disabled={isHiddenDisabled}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
      {showCheckbox && (
        <CheckBoxDiv>
          <SmallText data-disabled={isHiddenDisabled}>N/A</SmallText>

          <BlueCheckbox
            icon={
              <UncheckCircle
                color={isHiddenDisabled ? 'disabled' : undefined}
              />
            }
            checkedIcon={
              <CheckCircle color={isHiddenDisabled ? 'disabled' : undefined} />
            }
            onChange={() => {
              if (isHiddenDisabled) return;
              onClick();
            }}
            checked={value === 'Not Applicable'}
            disabled={isHiddenDisabled}
          />
        </CheckBoxDiv>
      )}
    </>
  );
};
